import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Front/Header";
import Footer from "./Front/Footer";
import API_BASE_URL from "../Config";
import { toast } from "react-toastify";
import "./styles/OrderBookingSuccess.css";
import "../styles/global.css";

/* ── Scoped styles (unchanged) ── */
// const styles = `

// .obs-wrap {
//   font-family: 'inter', sans-serif;
//   min-height: 60vh;
//   background: #f5f8f7;
//   display: flex;
//   align-items: center;
//   padding: 48px 0 64px;
// }

// /* Card */
// .obs-card {
//   background: #fff;
//   border-radius: 24px;
//   box-shadow: 0 8px 40px rgba(12,25,41,0.08);
//   padding: 48px 40px 40px;
//   text-align: center;
//   position: relative;
//   overflow: hidden;
// }

// .obs-card::before {
//   content: '';
//   position: absolute;
//   top: 0; left: 0; right: 0;
//   height: 5px;
//   border-radius: 24px 24px 0 0;
// }
// .obs-card.obs-success::before { background: linear-gradient(90deg, #1E7A8C, #3bb08f); }
// .obs-card.obs-failed::before  { background: linear-gradient(90deg, #ef4444, #f97316); }
// .obs-card.obs-loading::before { background: linear-gradient(90deg, #94a3b8, #cbd5e1); }

// /* Icon circle */
// .obs-icon-wrap {
//   width: 96px;
//   height: 96px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin: 0 auto 24px;
//   position: relative;
// }

// .obs-success .obs-icon-wrap {
//   background: linear-gradient(135deg, #e8f5f2, #d0f0e8);
//   box-shadow: 0 8px 24px rgba(30,122,140,0.15);
// }
// .obs-failed .obs-icon-wrap {
//   background: linear-gradient(135deg, #fef2f2, #fee2e2);
//   box-shadow: 0 8px 24px rgba(239,68,68,0.15);
// }

// .obs-icon-wrap svg { display: block; }

// /* Pulse ring on success */
// .obs-success .obs-icon-wrap::after {
//   content: '';
//   position: absolute;
//   inset: -8px;
//   border-radius: 50%;
//   border: 2px solid rgba(30,122,140,0.2);
//   animation: obsPulse 2s ease-out infinite;
// }
// @keyframes obsPulse {
//   0%   { transform: scale(1);   opacity: 1; }
//   100% { transform: scale(1.3); opacity: 0; }
// }

// /* Titles */
// .obs-title {
//   font-size: 1.4rem;
//   font-weight: 800;
//   letter-spacing: -0.02em;
//   margin-bottom: 8px;
//   line-height: 1.3;
// }
// .obs-success .obs-title { color: #0f172a; }
// .obs-failed  .obs-title { color: #0f172a; }

// .obs-sub {
//   font-size: 0.9rem;
//   color: #64748b;
//   font-weight: 500;
//   margin-bottom: 28px;
//   line-height: 1.6;
// }

// /* Order ID chip */
// .obs-order-chip {
//   display: inline-flex;
//   align-items: center;
//   gap: 8px;
//   background: #f1f5f9;
//   border: 1px solid #e2e8f0;
//   border-radius: 12px;
//   padding: 10px 18px;
//   font-size: 0.83rem;
//   font-weight: 600;
//   color: #475569;
//   margin-bottom: 28px;
// }
// .obs-order-chip span { color: #1E7A8C; font-weight: 700; }

// /* Info row (success) */
// .obs-info-row {
//   display: flex;
//   gap: 12px;
//   justify-content: center;
//   margin-bottom: 28px;
//   flex-wrap: wrap;
// }
// .obs-info-pill {
//   display: flex;
//   align-items: center;
//   gap: 7px;
//   background: #f8fafc;
//   border: 1px solid #eef1f6;
//   border-radius: 20px;
//   padding: 8px 16px;
//   font-size: 0.8rem;
//   font-weight: 600;
//   color: #475569;
// }
// .obs-info-pill i { color: #1E7A8C; font-size: 0.78rem; }

// /* Divider */
// .obs-divider {
//   height: 1px;
//   background: #f1f5f9;
//   margin: 0 -40px 28px;
// }

// /* Buttons */
// .obs-btn-primary {
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   gap: 8px;
//   background: linear-gradient(135deg, #1E7A8C, #238495);
//   color: #fff;
//   border: none;
//   border-radius: 12px;
//   padding: 14px 28px;
//   font-family: 'inter', sans-serif;
//   font-size: 0.92rem;
//   font-weight: 700;
//   text-decoration: none;
//   transition: all 0.2s;
//   box-shadow: 0 4px 16px rgba(30,122,140,0.25);
//   width: 100%;
//   margin-bottom: 10px;
// }
// .obs-btn-primary:hover {
//   color: #fff;
//   box-shadow: 0 6px 24px rgba(30,122,140,0.35);
//   transform: translateY(-1px);
// }

// .obs-btn-secondary {
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   gap: 8px;
//   background: #fff;
//   color: #475569;
//   border: 1.5px solid #e2e8f0;
//   border-radius: 12px;
//   padding: 13px 28px;
//   font-family: 'inter', sans-serif;
//   font-size: 0.88rem;
//   font-weight: 600;
//   text-decoration: none;
//   transition: all 0.2s;
//   width: 100%;
// }
// .obs-btn-secondary:hover {
//   color: #1E7A8C !important;
//   border-color: #1E7A8C important;
// }

// .obs-btn-danger {
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   gap: 8px;
//   background: linear-gradient(135deg, #ef4444, #f97316);
//   color: #fff;
//   border: none;
//   border-radius: 12px;
//   padding: 14px 28px;
//   font-family: 'inter', sans-serif;
//   font-size: 0.92rem;
//   font-weight: 700;
//   text-decoration: none;
//   transition: all 0.2s;
//   box-shadow: 0 4px 16px rgba(239,68,68,0.25);
//   width: 100%;
//   margin-bottom: 10px;
// }
// .obs-btn-danger:hover {
//   color: #fff;
//   box-shadow: 0 6px 24px rgba(239,68,68,0.35);
//   transform: translateY(-1px);
// }

// /* Loading spinner */
// .obs-spinner {
//   width: 52px;
//   height: 52px;
//   border: 4px solid #e2e8f0;
//   border-top-color: #1E7A8C;
//   border-radius: 50%;
//   animation: obsSpin 0.9s linear infinite;
//   margin: 0 auto 20px;
// }
// @keyframes obsSpin {
//   to { transform: rotate(360deg); }
// }

// /* Decorative bg dots */
// .obs-card .obs-dots {
//   position: absolute;
//   border-radius: 50%;
//   opacity: 0.04;
//   pointer-events: none;
// }
// .obs-dots-1 { width: 180px; height: 180px; background: #1E7A8C; top: -60px; right: -60px; }
// .obs-dots-2 { width: 120px; height: 120px; background: #1E7A8C; bottom: -40px; left: -40px; }

// /* Confetti dots on success */
// .obs-confetti {
//   position: absolute;
//   top: 0; left: 0; right: 0; bottom: 0;
//   pointer-events: none;
//   overflow: hidden;
//   border-radius: 24px;
// }
// .obs-confetti span {
//   position: absolute;
//   width: 8px; height: 8px;
//   border-radius: 2px;
//   opacity: 0;
//   animation: obsFall 3s ease-in forwards;
// }
// .obs-confetti span:nth-child(1)  { left: 10%; background: #1E7A8C; animation-delay: 0.1s; }
// .obs-confetti span:nth-child(2)  { left: 25%; background: #f4a623; animation-delay: 0.3s; width:6px; height:6px; }
// .obs-confetti span:nth-child(3)  { left: 40%; background: #3bb08f; animation-delay: 0.2s; border-radius:50%; }
// .obs-confetti span:nth-child(4)  { left: 60%; background: #1E7A8C; animation-delay: 0.4s; width:5px; height:5px; }
// .obs-confetti span:nth-child(5)  { left: 75%; background: #f4a623; animation-delay: 0.15s; }
// .obs-confetti span:nth-child(6)  { left: 88%; background: #3bb08f; animation-delay: 0.5s; border-radius:50%; width:6px; height:6px; }
// .obs-confetti span:nth-child(7)  { left: 50%; background: #1E7A8C; animation-delay: 0.35s; }
// .obs-confetti span:nth-child(8)  { left: 18%; background: #f97316; animation-delay: 0.25s; width:5px; height:5px; }

// @keyframes obsFall {
//   0%   { top: -10px; opacity: 1; transform: rotate(0deg) translateX(0); }
//   100% { top: 110%;  opacity: 0; transform: rotate(360deg) translateX(30px); }
// }

// /* Responsive */
// @media (max-width: 575px) {
//   .obs-card { padding: 36px 20px 28px; }
//   .obs-divider { margin: 0 -20px 24px; }
//   .obs-title  { font-size: 1.2rem; }
// }
// `;

const OrderBookingSuccess = () => {
  const [status, setStatus] = useState("loading"); // loading | success | failed
  const [orderId, setOrderId] = useState(null);

  // ─────────────────────────────────────────────────────────────
  // ✅ CHANGE — Track whether this was a free booking so we can
  // tweak the success message ("Booked" vs "Payment Successful").
  // ─────────────────────────────────────────────────────────────
  const [isFree, setIsFree] = useState(false);

  /* ── Original logic preserved + free-flow short-circuit ── */
  useEffect(() => {
    try {
      const hash = window.location.hash;
      const queryString = hash.includes("?") ? hash.split("?")[1] : "";
      const params = new URLSearchParams(queryString);
      const id = params.get("order_id");
      const free = params.get("free"); // ✅ new

      console.log("Order ID:", id, "Free flag:", free);

      // ─────────────────────────────────────────────────────────
      // ✅ CHANGE — Free-booking short-circuit
      // For zero-fee bookings, no Cashfree payment ever happens, so
      // there is nothing for /api/verify-booking-order to verify.
      // The booking has already been successfully created on the
      // server side (we got here BECAUSE /api/bookDoctor returned ok).
      // We just show the success state directly.
      //
      // We still set the orderId for display, even if it's our
      // placeholder "FREE-…" string, so the user has something to
      // reference. If you'd rather hide the chip when there's no
      // real ID, the JSX already only renders it when orderId truthy.
      // ─────────────────────────────────────────────────────────
      if (free === "1") {
        setIsFree(true);
        if (id && id !== "undefined") setOrderId(id);
        setStatus("success");
        return;
      }

      // ─────────── PAID FLOW (original logic, unchanged) ───────────
      if (!id || id === "undefined") {
        setStatus("failed");
        return;
      }

      setOrderId(id);

      fetch(`${API_BASE_URL}api/verify-booking-order/${id}`)
        .then((res) => res.json())
        .then((data) => {
          console.log("Verify Response:", data);
          if (data.order_status === "PAID") {
            setStatus("success");
          } else {
            setStatus("failed");
          }
        })
        .catch(() => {
          setStatus("failed");
        });
    } catch (err) {
      console.error(err);
      setStatus("failed");
    }
  }, []);

  return (
    <>
      {/* <style>{styles}</style> */}
      <Header />

      {/* Breadcrumb */}
      <section className="py-xl-5 py-3">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/home">Home</Link>
                  </li>
                  <li className="breadcrumb-item active">Order Status</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      {/* Main section */}
      <section className="obs-wrap cart-item-block cart-item-block-1">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-5 col-lg-6 col-md-8">

              {/* ── LOADING ── */}
              {status === "loading" && (
                <div className="obs-card obs-loading">
                  <div className="obs-dots obs-dots-1" />
                  <div className="obs-dots obs-dots-2" />
                  <div className="obs-spinner" />
                  <h3 className="obs-title" style={{ color: "#0f172a" }}>
                    {/* ✅ tweak label for free bookings */}
                    {isFree ? "Confirming Booking" : "Verifying Payment"}
                  </h3>
                  <p className="obs-sub">
                    {isFree
                      ? "Please wait while we confirm your appointment…"
                      : "Please wait while we confirm your booking…"}
                  </p>
                </div>
              )}

              {/* ── SUCCESS ── */}
              {status === "success" && (
                <div className="obs-card obs-success">
                  {/* Confetti */}
                  <div className="obs-confetti">
                    {[...Array(8)].map((_, i) => <span key={i} />)}
                  </div>
                  <div className="obs-dots obs-dots-1" />
                  <div className="obs-dots obs-dots-2" />

                  {/* Icon */}
                  <div className="obs-icon-wrap">
                    <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="12" fill="#1E7A8C" />
                      <polyline
                        points="6 12.5 10 16.5 18 8"
                        stroke="#fff"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>

                  <h3 className="obs-title">Appointment Confirmed!</h3>
                  <p className="obs-sub">
                    Your appointment has been successfully booked.<br />
                    We'll send a reminder before your visit.
                  </p>

                  {/* ✅ Show Order ID chip on success too (when available) */}
                  {orderId && (
                    <div className="obs-order-chip">
                      <i className="fa-solid fa-receipt" />
                      Order ID:&nbsp;<span>{orderId}</span>
                    </div>
                  )}

                  {/* Info pills — adjusted label for free bookings */}
                  <div className="obs-info-row">
                    <div className="obs-info-pill">
                      <i className="fa-solid fa-circle-check" />
                      {isFree ? "Free Consultation" : "Payment Successful"}
                    </div>
                    <div className="obs-info-pill">
                      <i className="fa-solid fa-calendar-check" />
                      Booking Confirmed
                    </div>
                  </div>

                  <div className="obs-divider" />

                  {/* Buttons */}
                  <Link to="/myprofile" className="obs-btn-primary btn btn-success py-3">
                    <i className="fa-solid fa-calendar-days" />
                    <span>Track Your Appointments</span>
                  </Link>
                  <Link to="/" className="obs-btn-secondary">
                    <i className="fa-solid fa-house" />
                    <span>Back to Home</span>
                  </Link>
                </div>
              )}

              {/* ── FAILED ── */}
              {status === "failed" && (
                <div className="obs-card obs-failed">
                  <div className="obs-dots obs-dots-1" style={{ background: "#ef4444" }} />
                  <div className="obs-dots obs-dots-2" style={{ background: "#f97316" }} />

                  {/* Icon */}
                  <div className="obs-icon-wrap">
                    <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="12" fill="#ef4444" />
                      <line x1="8" y1="8" x2="16" y2="16" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
                      <line x1="16" y1="8" x2="8" y2="16" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
                    </svg>
                  </div>

                  <h3 className="obs-title">Payment Failed</h3>
                  <p className="obs-sub">
                    We couldn't process your payment.<br />
                    Please try again or contact support.
                  </p>

                  {/* Order ID chip */}
                  {orderId && (
                    <div className="obs-order-chip">
                      <i className="fa-solid fa-receipt" />
                      Order ID: <span>{orderId}</span>
                    </div>
                  )}

                  <div className="obs-divider" />

                  <Link to="/cart" className="obs-btn-secondary mb-3">
                    <i className="fa-solid fa-rotate-right" />
                    Try Again
                  </Link>
                  <Link to="/" className="obs-btn-secondary">
                    <i className="fa-solid fa-house" />
                    Back to Home
                  </Link>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default OrderBookingSuccess;